<template>
<div class="material">
    <el-form-item label="题目" required>
        <uEditor :content="formData.subject" ref="subject" @getUEditorContent="getUEditorSubjectContent"></uEditor>
    </el-form-item>
    <el-form-item label="子试题" required>
        <questionList :dataList="formData.questioninfo" @editQues="updateDialog" @delQues="_delQues"></questionList>
        <el-button type="primary" @click="addDialog" class="add-ques" plain>添加子试题</el-button>
    </el-form-item>
    <el-form-item>
    </el-form-item>
    <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
    <quesEditDialog ref="quesEditDialog" @addQuesChild="_addQuesChild" @updateQuesChild="_updateQuesChild" :dataList="formData.questioninfo"></quesEditDialog>
</div>
</template>

<script>
import UEditor from 'base/uEditor/uEditor4'
import QuestionList from 'views/questionbank/components/questionList.vue'
import QuesEditDialog from 'views/questionbank/components/quesEditDialog.vue'
import {letter} from 'api/enumCode'
export default {
    name: 'material',
    props: ['formData'],
    data() {
        return {
            letter: letter,
            dataList: [],
            type: 1, // 1新增 2编辑
            selectedIndex: '',
        }
    },
    mounted() {
    },
    methods: {
        _setQuestionList() {
            let list = []
            this.formData.questioninfo.forEach((obj, index) => {
                list.push({
                    innerid: obj.innerid,
                    subject: obj.subject,
                    questiontype: obj.questiontype + '',
                    cateid: obj.cateid ? obj.cateid : '',
                    defaultscore: obj.defaultscore,
                    quesanalysis: obj.quesanalysis,
                    isquesorder: obj.isquesorder,
                    isscorebyblank: obj.isscorebyblank,
                    referenceanswer: obj.referenceanswer,
                    finalanswer: obj.questiontype + '' == 4 ? obj.finalanswer : '',
                    finalanswerblank: obj.questiontype + '' == 5 ? obj.finalanswerblank : [],
                    optioninfo: obj.optioninfo ? obj.optioninfo : [],
                    optionslist: obj.optioninfo ? obj.optioninfo : []
                })
            })
            this.formData.questioninfo = list
        },
        addDialog() {
            this.type = 1
            this.$refs.quesEditDialog.openDialog(this.type)
        },
        _addQuesChild(obj) {
            obj = this._setQuestioninfo(obj)
            this.formData.questioninfo.push(obj)
        },
        updateDialog(index) {
            this.selectedIndex = index
            this.type = 2
            this.$refs.quesEditDialog.openDialog(this.type, this.selectedIndex)
        },
        _delQues(index) {
            this.formData.questioninfo.splice(index, 1)
        },
        _updateQuesChild(obj, index) {
            this.selectedIndex = index
            obj = this._setQuestioninfo(obj)
            this.formData.questioninfo.splice(index, 1, obj)
        },
        _setQuestioninfo(obj) {
            if (['1','2','3'].indexOf(obj.questiontype) > -1) {
                let list = []
                let optioninfo = []
                obj.optioninfo = JSON.parse(obj.optioninfo)
                obj.optioninfo.forEach((obj, index) => {
                    optioninfo.push({
                        id: '',
                        isrightanswer: obj.isrightanswer * 1,
                        optionsinfo: obj.optionsinfo
                    })
                    list.push({
                        optionsvalue: letter[index],
                        optionsinfo: obj.optionsinfo,
                        isrightanswer: obj.isrightanswer
                    })
                })
                this.$set(obj, 'optionslist', list)
                obj.optioninfo = optioninfo
            } else if (['5'].indexOf(obj.questiontype) > -1) {
                let item = {answerblank: obj.finalanswer.split('|')}
                this.$set(obj, 'finalanswerblank', item)
            }
            return obj
        },
        getUEditorContent(content) {
            this.formData.referenceanswer = content
        },
        getUEditorSubjectContent(content) {
            this.formData.subject = content
        },
        cancel() {  // 返回题库
            this.$emit('cancel')
        },
        getUEditorQuesanalysisContent(content) {
            this.formData.quesanalysis = content
        },
        submit() {
            let item = this._.cloneDeep(this.formData)
            item.optioninfo = ''
            if (item.questioninfo.length > 0) {
                item.questioninfo.forEach(obj => {
                    if (['1','2','3'].indexOf(obj.questiontype) > -1) {
                        delete obj.finalanswerblank
                        obj.optionslist = obj.optioninfo.length ? obj.optioninfo : obj.optionslist
                        delete obj.optioninfo
                    } else if (['5'].indexOf(obj.questiontype) > -1) {
                        obj.finalanswer = obj.finalanswerblank.answerblank.join('|')
                        delete obj.finalanswerblank
                    }
                })
                this.$emit('childSubmitFormApi', JSON.stringify(item))
            } else {
                this.$message.error('请添加子试题')
            }
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UEditor, QuestionList, QuesEditDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.material {
    .uEditor {
        .ue_btn {
            display: none;
        }
    }
    .questionList+.el-button{
        margin-top: 20px;
    }
    .add-ques{
        width: 360px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
